/**
 * The email hover's provenance lines (`contacts.emailProvenance`, PREC-4262): where the caller's
 * company got the address, its last verification and the lead's last email. Each verifier answer and
 * each outcome has its own key; an answer without one reads as `verification.checked`, never as the
 * raw provider value.
 */
export const enEmailProvenance = {
	labels: {
		source: "Source",
		verified: "Verified",
		lastSent: "Last sent",
	},
	source: {
		signalist: "Enriched by Signalist",
		manual: "Added manually",
		userProvided: "Provided by you",
	},
	verification: {
		valid: "Valid",
		invalid: "Invalid",
		catch_all: "Catch-all",
		unknown: "Unknown",
		checked: "Checked",
	},
	outcome: {
		SENT: "Sent",
		BOUNCED: "Bounced",
	},
};
